module.exports = {
          srcSet: __webpack_public_path__ + "1586bddcebc42cf9826cc0706eda157e-50.png"+" 50w",
          images:[ {path: __webpack_public_path__ + "1586bddcebc42cf9826cc0706eda157e-50.png",width: 50,height: 50}],
          src: __webpack_public_path__ + "1586bddcebc42cf9826cc0706eda157e-50.png",
          toString:function(){return __webpack_public_path__ + "1586bddcebc42cf9826cc0706eda157e-50.png"},
          
          width: 50,
          height: 50
        }